// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__20UEG","title":"AfterFrontImage_title__3fpH_"};